module.exports = __webpack_public_path__ + "media/chess-pieces.0faf8100.mp3";